<template>
    <QS-common-table
      :data="tableData"
      :columns="orderTableColumns"
      row-key="id"
      :pagination="paginationData"
      @change="paginationChange"
    />
</template>

<script>
import config from '../config'

export default {
  name: 'OrderDetail',
  props: {
    paginationData: {
      type: Object,
      default: () => ({}),
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const { orderTableColumns } = config.call(this)
    return {
      orderTableColumns,
    }
  },
  methods: {
    paginationChange(payload) {
      this.$emit('paginationChange', payload)
    },
  },
}
</script>

<style lang="scss"></style>
